import { memo } from 'react';
import { Link } from 'react-router-dom';
import { 
  Mail, 
  Linkedin, 
  Twitter, 
  Instagram,
  MapPin,
  Heart,
  Phone
} from 'lucide-react';
import logoPrimary from '../assets/images/LOGO_PRIMARY.png';

export const Footer = memo(function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#052A44] text-white pt-16 pb-8 border-t border-white/10">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {/* Column 1: Brand Identity */}
          <div className="space-y-6">
            <Link to="/" className="block">
              <img 
                src={logoPrimary} 
                alt="Brainsie" 
                className="h-10 w-auto brightness-0 invert" 
              />
            </Link>
            <p className="text-white/70 text-sm leading-relaxed">
              Orchestrating the Intelligent Future. We enable businesses to scale through AI-driven strategies, robust cloud infrastructure, and modern commerce platforms.
            </p>

            <div className="flex gap-4 pt-4">
              <a href="https://linkedin.com/company/brainsie" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-[#00A8E8] transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="https://twitter.com/brainsie" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-[#00A8E8] transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="https://instagram.com/brainsie" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-[#00A8E8] transition-colors">
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Column 2: Services */}
          <div>
            <h3 className="text-white font-semibold mb-6">Services</h3>
            <ul className="space-y-4 text-sm text-white/70">
              <li>
                <Link to="/consulting" className="hover:text-[#00A8E8] transition-colors">
                  Enterprise AI Strategy
                </Link>
              </li>
              <li>
                <Link to="/small-business" className="hover:text-[#00A8E8] transition-colors">
                  Small Business Solutions
                </Link>
              </li>
              <li>
                <Link to="/platform" className="hover:text-[#00A8E8] transition-colors">
                  Brainsie Platform
                </Link>
              </li>
              <li>
                <Link to="/consulting" className="hover:text-[#00A8E8] transition-colors">
                  Digital Transformation
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Company */}
          <div>
            <h3 className="text-white font-semibold mb-6">Company</h3>
            <ul className="space-y-4 text-sm text-white/70">
              <li>
                <Link to="/about" className="hover:text-[#00A8E8] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/careers" className="hover:text-[#00A8E8] transition-colors">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/blogs" className="hover:text-[#00A8E8] transition-colors">
                  Insights & Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-[#00A8E8] transition-colors">
                  Contact Support
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact & HQ */}
          <div>
            <h3 className="text-white font-semibold mb-6">Connect</h3>
            <ul className="space-y-4 text-sm text-white/70">
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-[#00A8E8] shrink-0" />
                <a href="mailto:info@brainsietech.com" className="hover:text-white transition-colors">
                  info@brainsietech.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-[#00A8E8] shrink-0" />
                <a href="tel:+917205572217" className="hover:text-white transition-colors">
                  +91 7205572217 (India)
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-[#00A8E8] shrink-0" />
                <div className="space-y-2">
                  <p>Tamando, Bhubaneswar, Odisha 752054</p>
                  <p>Cheyenne, WY 82001 (USA)</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/50">
          <div className="flex flex-wrap justify-center md:justify-start gap-6">
            <span>&copy; {currentYear} Brainsie Technologies Pvt Ltd (India) & Brainsie Consulting LLC (USA). All Rights Reserved.</span>
          </div>
          <div className="flex flex-wrap justify-center gap-6">
            <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</Link>
            <Link to="/sitemap.xml" className="hover:text-white transition-colors">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
});
